import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SeasonalBanner from './SeasonalBanner';

export default class SeasonalDropdown extends PureComponent {
  static propTypes = {
    seasonalEvents: PropTypes.array,
  };

  render() {
    const { seasonalEvents } = this.props;

    return (
      <div className={classNames('hd-events', `hd-events--len-${seasonalEvents && seasonalEvents.length}`)}>
        {seasonalEvents && seasonalEvents.map((seasonalEvent, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SeasonalBanner key={index} seasonalEvent={seasonalEvent} />
        ))}
      </div>
    );
  }
}
